import { render, staticRenderFns } from "./RegisterPhone.vue?vue&type=template&id=6e895b0d&scoped=true&"
import script from "./RegisterPhone.vue?vue&type=script&lang=js&"
export * from "./RegisterPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e895b0d",
  null
  
)

export default component.exports